// UK-specific content (existing)
export const sandboxcontentUK = [
  // New Section 1: In Class Videos
  {
    folderName: "In Class Videos",
    cards: [
      {
        title: "Reception Baseline Screener Walk Through",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/nxMDULDDMo8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>',
      },
      {
        title: "Year 1 Baseline Screener Walk Through",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/5JWSSI9jRys" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>',
      },
    ],
  },
  // New Section 2: Word & Image Lists
  {
    folderName: "Word & Image Lists",
    cards: [
      {
        title: "Reception Word List - Baseline Screener",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Reception%20Baseline%20Word%20&%20Image%20list.pdf",
      },
      {
        title: "Year 1 Word List - Baseline Screener",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/Year%201%20Baseline%20Word%20&%20Image%20list.pdf",
      },
    ],
  },
  // Keep existing folders with their original content
  {
    folderName: "Getting Started with the Platform",
    cards: [
      {
        title: "Account Creation",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/-tHHE3UZsKM?si=iOr0DC_l5HCDJZFv" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Navigating the ALPACA Teacher Dashboard",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/Gd9uNam1YqA?si=SmXSgELkGU6vfMM5" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Claiming a Converted Classroom",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/KQE9rRB5BRo?si=T24muP-aOvCwd2q2" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "How to Invite Colleagues",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/ZzcP4ZAVOBg?si=wqXJeO17YSe98SUB" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "How to Share a Class with a Colleague",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/WI2EiLKhxo0?si=iAHz2pWisrljga8P" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
    ],
  },
  {
    folderName: "Before Screening Day",
    cards: [
      {
        title: "Hints & Tips For Screening",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/wQIKM3UAQww?si=EmSSDyKaRShjA7lB" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Trial Screener Walkthrough",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/mqD8BKTe58s?si=TaF9cvQ5m_if38wa" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Screener Best Practices",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/6a4sLVTmfFA?si=eg09UK9l0d4gi581" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
    ],
  },
  {
    folderName: "Results After Screening Day",
    cards: [
      {
        title: "Analysing Results Guide",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/Ps2u5xhm1Pk?si=ntiGfa6K8ZosoJL3" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Retake Tasks Guide",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/SSOmLJBEKTk?si=WTJmdI2_nyEdl9wf" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
    ],
  },
];

export const additionalResourcesESLUK = [
  {
    folderName: "Additional Resources",
    cards: [
      {
        title: "Importance Of Early Intervention",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/J_O0HnA9Njo?si=pOW_-AensxKmtpPw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Benefits Of ALPACA",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/CXOWin_jE0Q?si=2Oetiy_kFoSXwhoQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "How ALPACA Impacted Teaching",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/TB1n6IZ5qKM?si=DunpZSlZHb-aU5pt" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "How To Engage With The Wider Team",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/-qFj4NJZW18?si=XKZgqyS58UO3gD2x" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Why ALPACA",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/1CVrNF5fCmM?si=rhwwkXzdTagjD3rO" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Reception Open Evening",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/UK%20Specific/Parents%20Evening%20PDF.pdf",
      },
      {
        title: "Assessment Best Practices",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Additional%20Resources/Assessment%20Best%20Practice%20(2).pdf",
      },
      {
        title: "Your Team Worksheet + Next Steps",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/UK%20Specific/Parents%20Evening%20PDF.pdf",
      },
      {
        title: "ALPACA Screener Observation Sheet",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Additional%20Resources/ALPACA%20Screener%20Observation%20Sheet.pdf",
      },
      {
        title: "Areas Screened - Reception",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Additional%20Resources/Areas%20screened%20-%20Jnr%20Infants.pdf",
      },
      {
        title: "Areas Screened - Year 1 Today",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Additional%20Resources/Areas%20Screened-SI%20screener.pdf",
      },
      {
        title: "Early Intervention Tools ALPACA Press Coverage",
        documentUrl:
          "https://26983596.hs-sites-eu1.com/early-intervention-tools-alpaca-press-coverage",
      },
    ],
  },
  {
    folderName: "EAL",
    cards: [
      {
        title: "EAL Introduction",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/8bJiVLMxeAc?si=efLV_CQF50Pmx6AK" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Reception Baseline Screener Walk Through",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/nxMDULDDMo8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      /*
      Non-baseline UK walkthroughs

      {
        title: "Reception Midpoint Screener Walk Through",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/EoMI0IQZotw?si=zrDWzs1thh_pTM4L" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Reception End of Year Screener Walk Through",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/plCRmbxWJSc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      */
      {
        title: "Year 1 Baseline Screener Walk Through",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/5JWSSI9jRys" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      /*
      {
        title: "Year 1 Midpoint Screener Walk Through",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/dTYTEW9BAzI?si=XU1HxlCgCWe13po2" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Year 1 End of Year Screener Walk Through",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/US30ANx_wH8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      */
      {
        title: "Reception Word List - Baseline Screener",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Reception%20Baseline%20Word%20&%20Image%20list.pdf",
      },
      {
        title: "Year 1 Word List - Baseline Screener",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/Year%201%20Baseline%20Word%20&%20Image%20list.pdf",
      },
      /*
      Non-baseline UK word and image lists

      {
        title: "Reception Word List - Midpoint Screener",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Additional%20Resources/GradeLevel1%20Word%20&%20Image%20list%20-%20Midpoint.pdf",
      },
      {
        title: "Year 1 Word List - Midpoint Screener",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Additional%20Resources/GradeLevel2%20Word%20&%20Image%20list%20-%20Midpoint.pdf",
      },
      {
        title: "Reception Word List - End of Year Screener",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/Reception%20Word%20&%20Image%20list%20-%20End%20of%20Year_v1%20(1).pdf",
      },
      {
        title: "Year 1 Word List - End of Year Screener",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/Year%201%20%20Word%20&%20Image%20list%20-%20End%20of%20Year.pdf",
      },
      */
    ],
  },
];

// USA-specific content
export const sandboxcontentUSA = [
  // New Section 1: In Class Videos
  {
    folderName: "In Class Videos",
    cards: [
      {
        title: "Pre-K Midpoint Screener Walk Through",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/Wze4acpFG5M?si=R9Qgu65LZgW_T4Z_" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>',
      },
      {
        title: "Kindergarten Midpoint Screener Walk Through",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/04gpHzRb-q4?si=mrHMYb6uiczXrydM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>',
      },
    ],
  },
  // New Section 2: Word & Image Lists
  {
    folderName: "Word & Image Lists",
    cards: [
      {
        title: "Pre-K Word List - Midpoint Screener",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Additional%20Resources/GradeLevel1%20Word%20&%20Image%20list%20-%20Midpoint.pdf",
      },
      {
        title: "Kindergarten Word List - Midpoint Screener",
        documentUrl:
        "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Additional%20Resources/GradeLevel2%20Word%20&%20Image%20list%20-%20Midpoint.pdf",
      },
    ],
  },
  // Keep existing folders with their original content (same as UK)
  {
    folderName: "Getting Started with the Platform",
    cards: [
      {
        title: "Account Creation",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/-tHHE3UZsKM?si=iOr0DC_l5HCDJZFv" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Navigating the ALPACA Teacher Dashboard",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/Gd9uNam1YqA?si=SmXSgELkGU6vfMM5" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Claiming a Converted Classroom",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/KQE9rRB5BRo?si=T24muP-aOvCwd2q2" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "How to Invite Colleagues",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/ZzcP4ZAVOBg?si=wqXJeO17YSe98SUB" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "How to Share a Class with a Colleague",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/WI2EiLKhxo0?si=iAHz2pWisrljga8P" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
    ],
  },
  {
    folderName: "Before Screening Day",
    cards: [
      {
        title: "Hints & Tips For Screening",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/wQIKM3UAQww?si=EmSSDyKaRShjA7lB" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Trial Screener Walkthrough",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/mqD8BKTe58s?si=TaF9cvQ5m_if38wa" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Screener Best Practices",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/6a4sLVTmfFA?si=eg09UK9l0d4gi581" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
    ],
  },
  {
    folderName: "Results After Screening Day",
    cards: [
      {
        title: "Analysing Results Guide",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/Ps2u5xhm1Pk?si=ntiGfa6K8ZosoJL3" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Retake Tasks Guide",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/SSOmLJBEKTk?si=WTJmdI2_nyEdl9wf" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
    ],
  },
];

export const additionalResourcesESLUSA = [
  {
    folderName: "Additional Resources",
    cards: [
      {
        title: "Importance Of Early Intervention",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/J_O0HnA9Njo?si=pOW_-AensxKmtpPw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Benefits Of ALPACA",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/CXOWin_jE0Q?si=2Oetiy_kFoSXwhoQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "How ALPACA Impacted Teaching",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/TB1n6IZ5qKM?si=DunpZSlZHb-aU5pt" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "How To Engage With The Wider Team",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/-qFj4NJZW18?si=XKZgqyS58UO3gD2x" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Why ALPACA",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/1CVrNF5fCmM?si=rhwwkXzdTagjD3rO" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Assessment Best Practices",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Additional%20Resources/Assessment%20Best%20Practice%20(2).pdf",
      },
      {
        title: "ALPACA Screener Observation Sheet",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Additional%20Resources/ALPACA%20Screener%20Observation%20Sheet.pdf",
      },
      {
        title: "Areas Screened - Pre-K",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Additional%20Resources/Areas%20screened%20-%20Jnr%20Infants.pdf",
      },
      {
        title: "Areas Screened - Kindergarten",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Additional%20Resources/Areas%20Screened-SI%20screener.pdf",
      },
      {
        title: "Early Intervention Tools ALPACA Press Coverage",
        documentUrl:
          "https://26983596.hs-sites-eu1.com/early-intervention-tools-alpaca-press-coverage",
      },
    ],
  },
  {
    folderName: "EAL/ESL",
    cards: [
      {
        title: "EAL/ESL Introduction",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/8bJiVLMxeAc?si=efLV_CQF50Pmx6AK" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Pre-K Word List - Baseline Screener",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/EAL/Junior%20Infant%20Wordlist%20Baseline%20Screener.pdf",
      },
      {
        title: "Kindergarten Word List - Baseline Screener",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/EAL/Senior%20Infant%20WordList%20Baseline%20Screener.pdf",
      },
      {
        title: "Pre-K Word List - Midpoint Screener",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Additional%20Resources/GradeLevel1%20Word%20&%20Image%20list%20-%20Midpoint.pdf",
      },
      {
        title: "Kindergarten Word List - Midpoint Screener",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Additional%20Resources/GradeLevel2%20Word%20&%20Image%20list%20-%20Midpoint.pdf",
      },
    ],
  },
];

// UAE-specific content
export const sandboxcontentUAE = [
  // New Section 1: In Class Videos
  {
    folderName: "In Class Videos",
    cards: [
      {
        title: "KG1 Baseline Screener Walk Through",
        // Previous version walkthrough: "https://www.youtube.com/embed/QoBdurA2I4Y"
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/gMrbihlzlVI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>',
      },
      {
        title: "KG2 Baseline Screener Walk Through",
        // Previous version walkthrough: "https://www.youtube.com/embed/Ipcsw8BsEAE"
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/nesNSdq3oX4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>',
      },
    ],
  },
  // New Section 2: Word & Image Lists
  {
    folderName: "Word & Image Lists",
    cards: [
      {
        title: "KG1 Word List - Baseline Screener",
        // Previous version document: "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/KG1%20Baseline%20Word%20&%20Image%20list.pdf"
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/chatbot%20video/KG1%20Baseline%20Word%20&%20Image%20list%20V2.pdf",
      },
      {
        title: "KG2 Word List - Baseline Screener",
        // Previous version document: "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/KG2%20Baseline%20Word%20&%20Image%20list.pdf"
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/chatbot%20video/KG2%20Baseline%20Word%20&%20Image%20list%20V2.pdf",
      },
    ],
  },
  // Keep existing folders with their original content (same as UK)
  {
    folderName: "Getting Started with the Platform",
    cards: [
      {
        title: "Account Creation",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/-tHHE3UZsKM?si=iOr0DC_l5HCDJZFv" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Navigating the ALPACA Teacher Dashboard",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/Gd9uNam1YqA?si=SmXSgELkGU6vfMM5" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Claiming a Converted Classroom",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/KQE9rRB5BRo?si=T24muP-aOvCwd2q2" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "How to Invite Colleagues",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/ZzcP4ZAVOBg?si=wqXJeO17YSe98SUB" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "How to Share a Class with a Colleague",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/WI2EiLKhxo0?si=iAHz2pWisrljga8P" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
    ],
  },
  {
    folderName: "Before Screening Day",
    cards: [
      {
        title: "Hints & Tips For Screening",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/wQIKM3UAQww?si=EmSSDyKaRShjA7lB" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Trial Screener Walkthrough",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/mqD8BKTe58s?si=TaF9cvQ5m_if38wa" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Screener Best Practices",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/6a4sLVTmfFA?si=eg09UK9l0d4gi581" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
    ],
  },
  {
    folderName: "Results After Screening Day",
    cards: [
      {
        title: "Analysing Results Guide",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/Ps2u5xhm1Pk?si=ntiGfa6K8ZosoJL3" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Retake Tasks Guide",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/SSOmLJBEKTk?si=WTJmdI2_nyEdl9wf" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
    ],
  },
];

export const additionalResourcesESLUAE = [
  {
    folderName: "Additional Resources",
    cards: [
      {
        title: "Importance Of Early Intervention",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/J_O0HnA9Njo?si=pOW_-AensxKmtpPw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Benefits Of ALPACA",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/CXOWin_jE0Q?si=2Oetiy_kFoSXwhoQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "How ALPACA Impacted Teaching",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/TB1n6IZ5qKM?si=DunpZSlZHb-aU5pt" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "How To Engage With The Wider Team",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/-qFj4NJZW18?si=XKZgqyS58UO3gD2x" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Why ALPACA",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/1CVrNF5fCmM?si=rhwwkXzdTagjD3rO" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Assessment Best Practices",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Additional%20Resources/Assessment%20Best%20Practice%20(2).pdf",
      },
      {
        title: "ALPACA Screener Observation Sheet",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Additional%20Resources/ALPACA%20Screener%20Observation%20Sheet.pdf",
      },
      {
        title: "Areas Screened - KG1",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Additional%20Resources/Areas%20screened%20-%20Jnr%20Infants.pdf",
      },
      {
        title: "Areas Screened - KG2",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Additional%20Resources/Areas%20Screened-SI%20screener.pdf",
      },
      {
        title: "Early Intervention Tools ALPACA Press Coverage",
        documentUrl:
          "https://26983596.hs-sites-eu1.com/early-intervention-tools-alpaca-press-coverage",
      },
    ],
  },
  {
    folderName: "EAL",
    cards: [
      {
        title: "EAL Introduction",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/8bJiVLMxeAc?si=efLV_CQF50Pmx6AK" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "KG1 Word List - Baseline Screener",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/chatbot%20video/KG1%20Baseline%20Word%20&%20Image%20list%20V2.pdf",
      },
      {
        title: "KG2 Word List - Baseline Screener",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/chatbot%20video/KG2%20Baseline%20Word%20&%20Image%20list%20V2.pdf",
      },
      /*
      Non-baseline UAE word and image lists

      {
        title: "KG1 Word List - Midpoint Screener",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Additional%20Resources/GradeLevel1%20Word%20&%20Image%20list%20-%20Midpoint.pdf",
      },
      {
        title: "KG2 Word List - Midpoint Screener",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Additional%20Resources/GradeLevel2%20Word%20&%20Image%20list%20-%20Midpoint.pdf",
      },
      {
        title: "KG1 Word List - End of Year Screener",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/KG1%20Word%20&%20Image%20list%20-%20End%20of%20Year_v1.pdf",
      },
      {
        title: "KG2 Word List - End of Year Screener",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/KG2%20Word%20&%20Image%20list%20-%20End%20of%20Year.pdf",
      },
      */
      {
        title: "KG1 Baseline Screener Walkthrough",
        iframe:
         '<iframe width="672" height="378" src="https://www.youtube.com/embed/gMrbihlzlVI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>'
      },
      {
        title: "KG2 Baseline Screener Walkthrough",
        iframe:
         '<iframe width="672" height="378" src="https://www.youtube.com/embed/nesNSdq3oX4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>'
      },
      /*
      Non-baseline UAE walkthroughs

      {
        title: "KG1 Midpoint Screener Walkthrough",
        iframe:
         '<iframe width="672" height="378" src="https://www.youtube.com/embed/gxXt6iY079s" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>'
      },
      {
        title: "KG2 Midpoint Screener Walkthrough",
        iframe:
         '<iframe width="672" height="378" src="https://www.youtube.com/embed/Xx6EAPt1ymA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>'
      },
      {
        title: "KG1 End of Year Screener Walkthrough",
        iframe:
         '<iframe width="672" height="378" src="https://www.youtube.com/embed/N668kgql9go" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>'
      },
      {
        title: "KG2 End of Year Screener Walkthrough",
        iframe:
         '<iframe width="672" height="378" src="https://www.youtube.com/embed/HiSl6NUA3rs" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>'
      },
      */
    ],
  },
];
export const sandboxcontentNI = [
  // New Section 1: In Class Videos
  {
    folderName: "In Class Videos",
    cards: [
      {
          title: "P1 Baseline Screener Walk Through",
          // Irish Version: "https://www.youtube.com/embed/i0gclNlkfCM"
          iframe:
            '<iframe width="672" height="378" src="https://www.youtube.com/embed/J7m0DRW8DiM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
        },
        {
          title: "P2 Baseline Screener Walk Through",
          // Irish Version: "https://www.youtube.com/embed/l3jRDUCs77E"
          iframe:
            '<iframe width="672" height="378" src="https://www.youtube.com/embed/09tQNqn3ICo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
        },
    ],
  },
  // New Section 2: Word & Image Lists
  {
    folderName: "Word & Image Lists",
    cards: [
      {
        title: "P1 Word List - Baseline Screener",
        // Irish Version: "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/chatbot%20video/P1%20Baseline%20Word%20&%20Image%20list%20-%20Ire%20Version.pdf"
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/P1%20Baseline%20Word%20&%20Image%20list.pdf",
      },
      {
        title: "P2 Word List - Baseline Screener",
        // Irish Version: "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/chatbot%20video/P2%20Baseline%20Word%20&%20Image%20list%20-%20Ire%20Version.pdf"
        documentUrl:
        "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/P2%20Baseline%20Word%20&%20Image%20list.pdf",
      },
    ],
  },
  // Keep existing folders with their original content
  {
    folderName: "Getting Started with the Platform",
    cards: [
      {
        title: "Account Creation",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/-tHHE3UZsKM?si=iOr0DC_l5HCDJZFv" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Navigating the ALPACA Teacher Dashboard",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/Gd9uNam1YqA?si=SmXSgELkGU6vfMM5" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Claiming a Converted Classroom",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/KQE9rRB5BRo?si=T24muP-aOvCwd2q2" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Importing Class Lists into ALPACA From Aladdin",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/v5F5Hj-q2b4?si=R_OmFOCDzS0g7Jyz" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "How to Invite Colleagues",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/ZzcP4ZAVOBg?si=wqXJeO17YSe98SUB" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "How to Share a Class with a Colleague",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/WI2EiLKhxo0?si=iAHz2pWisrljga8P" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
    ],
  },
  {
    folderName: "Before Screening Day",
    cards: [
      {
        title: "Hints & Tips For Screening",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/wQIKM3UAQww?si=EmSSDyKaRShjA7lB" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Trial Screener Walkthrough",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/mqD8BKTe58s?si=TaF9cvQ5m_if38wa" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Screener Best Practices",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/6a4sLVTmfFA?si=eg09UK9l0d4gi581" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
    ],
  },
  {
    folderName: "Results After Screening Day",
    cards: [
      {
        title: "Analysing Results Guide",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/Ps2u5xhm1Pk?si=ntiGfa6K8ZosoJL3" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Retake Tasks Guide",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/SSOmLJBEKTk?si=WTJmdI2_nyEdl9wf" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
    ],
  },
];

export const additionalResourcesESLNI = [
  {
    folderName: "Additional Resources",
    cards: [
      {
        title: "Importance Of Early Intervention",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/J_O0HnA9Njo?si=pOW_-AensxKmtpPw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Benefits Of ALPACA",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/CXOWin_jE0Q?si=2Oetiy_kFoSXwhoQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "How ALPACA Impacted Teaching",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/TB1n6IZ5qKM?si=DunpZSlZHb-aU5pt" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "How To Engage With The Wider Team",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/-qFj4NJZW18?si=XKZgqyS58UO3gD2x" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Why ALPACA",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/1CVrNF5fCmM?si=rhwwkXzdTagjD3rO" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Assessment Best Practices",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Additional%20Resources/Assessment%20Best%20Practice%20(2).pdf",
      },
      {
        title: "ALPACA Team Infographic",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Additional%20Resources/Alpaca%20Team%20Infographic.pptx",
      },
      {
        title: "ALPACA Screener Observation Sheet",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Additional%20Resources/ALPACA%20Screener%20Observation%20Sheet.pdf",
      },
      {
        title: "Early Intervention Tools ALPACA Press Coverage",
        documentUrl:
          "https://26983596.hs-sites-eu1.com/early-intervention-tools-alpaca-press-coverage",
      },
    ],
  },
  {
    folderName: "EAL",
    cards: [
      {
        title: "EAL Introduction",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/8bJiVLMxeAc?si=efLV_CQF50Pmx6AK" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "P1 Baseline Screener Walk Through",
        // Irish Version: "https://www.youtube.com/embed/i0gclNlkfCM"
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/J7m0DRW8DiM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "P2 Baseline Screener Walk Through",
        // Irish Version: "https://www.youtube.com/embed/l3jRDUCs77E"
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/09tQNqn3ICo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      /*
      Non-baseline Northern Ireland walkthroughs

      {
        title: "P1 Midpoint Screener Walk Through",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/S8yxYpNQxUI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "P2 Midpoint Screener Walk Through",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/drxJv91P5iU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "P1 End of Year Screener Walk Through",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/OgHdKc1w_Jc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "P2 End of Year Screener Walk Through",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/6VJOX02u_s0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      */
      {
        title: "P1 Word List - Baseline Screener",
        // Irish Version: "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/chatbot%20video/P1%20Baseline%20Word%20&%20Image%20list%20-%20Ire%20Version.pdf"
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/P1%20Baseline%20Word%20&%20Image%20list.pdf",
      },
      {
        title: "P2 Word List - Baseline Screener",
        // Irish Version: "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/chatbot%20video/P2%20Baseline%20Word%20&%20Image%20list%20-%20Ire%20Version.pdf"
        documentUrl:
        "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/P2%20Baseline%20Word%20&%20Image%20list.pdf",
      },
      /*
      Non-baseline Northern Ireland word and image lists

      {
        title: "P1 Word List - Midpoint Screener",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/chatbot%20video/P1%20Word%20&%20Image%20list%20Midpoint%20-%20Irish%20version.pdf",
      },
      {
        title: "P2 Word List - Midpoint Screener",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/chatbot%20video/P2%20Word%20&%20Image%20list%20-%20Midpoint%20Irish%20version.pdf",
      },
      {
        title: "P1 Word List - End of Year Screener",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/P1%20Word%20&%20Image%20list%20-%20End%20of%20Year.pdf",
      },
      {
        title: "P2 Word List - End of Year Screener",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/P2%20Word%20&%20Image%20list%20-%20End%20of%20Year.pdf",
      },
      */
    ],
  },
];

export const sandboxcontentIndia = [
  // New Section 1: In Class Videos
  {
    folderName: "In Class Videos",
    cards: [
      {
        title: "LKG Baseline Screener Walk Through",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/D5FeMLrFOjA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>',
      },
      {
        title: "UKG Baseline Screener Walk Through",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/FiJOsoI9lls" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>',
      },
    ],
  },
  // New Section 2: Word & Image Lists
  {
    folderName: "Word & Image Lists",
    cards: [
      {
        title: "LKG Word List - Baseline Screener",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/India%20LKG%20Baseline%20Word%20&%20Image%20list.pdf",
      },
      {
        title: "UKG Word List - Baseline Screener",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/India%20UKG%20Baseline%20Word%20&%20Image%20list.pdf",
      },
    ],
  },
  // Keep existing folders with their original content
  {
    folderName: "Getting Started with the Platform",
    cards: [
      {
        title: "Account Creation",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/-tHHE3UZsKM?si=iOr0DC_l5HCDJZFv" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Navigating the ALPACA Teacher Dashboard",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/Gd9uNam1YqA?si=SmXSgELkGU6vfMM5" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Claiming a Converted Classroom",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/KQE9rRB5BRo?si=T24muP-aOvCwd2q2" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "How to Invite Colleagues",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/ZzcP4ZAVOBg?si=wqXJeO17YSe98SUB" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "How to Share a Class with a Colleague",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/WI2EiLKhxo0?si=iAHz2pWisrljga8P" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
    ],
  },
  {
    folderName: "Before Screening Day",
    cards: [
      {
        title: "Hints & Tips For Screening",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/wQIKM3UAQww?si=EmSSDyKaRShjA7lB" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Trial Screener Walkthrough",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/mqD8BKTe58s?si=TaF9cvQ5m_if38wa" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Screener Best Practices",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/6a4sLVTmfFA?si=eg09UK9l0d4gi581" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
    ],
  },
  {
    folderName: "Results After Screening Day",
    cards: [
      {
        title: "Analysing Results Guide",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/Ps2u5xhm1Pk?si=ntiGfa6K8ZosoJL3" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Retake Tasks Guide",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/SSOmLJBEKTk?si=WTJmdI2_nyEdl9wf" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
    ],
  },
];

export const additionalResourcesESLIndia = [
  {
    folderName: "Additional Resources",
    cards: [
      {
        title: "Importance Of Early Intervention",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/J_O0HnA9Njo?si=pOW_-AensxKmtpPw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Benefits Of ALPACA",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/CXOWin_jE0Q?si=2Oetiy_kFoSXwhoQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "How ALPACA Impacted Teaching",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/TB1n6IZ5qKM?si=DunpZSlZHb-aU5pt" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "How To Engage With The Wider Team",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/-qFj4NJZW18?si=XKZgqyS58UO3gD2x" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Why ALPACA",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/1CVrNF5fCmM?si=rhwwkXzdTagjD3rO" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "Assessment Best Practices",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Additional%20Resources/Assessment%20Best%20Practice%20(2).pdf",
      },
      {
        title: "Your Team Worksheet + Next Steps",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/UK%20Specific/Parents%20Evening%20PDF.pdf",
      },
      {
        title: "ALPACA Screener Observation Sheet",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Additional%20Resources/ALPACA%20Screener%20Observation%20Sheet.pdf",
      },
      {
        title: "Early Intervention Tools ALPACA Press Coverage",
        documentUrl:
          "https://26983596.hs-sites-eu1.com/early-intervention-tools-alpaca-press-coverage",
      },
    ],
  },
  {
    folderName: "EAL",
    cards: [
      {
        title: "EAL Introduction",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/8bJiVLMxeAc?si=efLV_CQF50Pmx6AK" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "LKG Baseline Screener Walk Through",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/D5FeMLrFOjA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "UKG Baseline Screener Walk Through",
        iframe:
          '<iframe width="672" height="378" src="https://www.youtube.com/embed/FiJOsoI9lls" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
      },
      {
        title: "LKG Word List - Baseline Screener",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/India%20LKG%20Baseline%20Word%20&%20Image%20list.pdf",
      },
      {
        title: "UKG Word List - Baseline Screener",
        documentUrl:
          "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/India%20UKG%20Baseline%20Word%20&%20Image%20list.pdf",
      },
    ],
  },
];